import Keycloak from "keycloak-js";

const options = {
  realm: process.env.VUE_APP_KEYCLOAK_REALM,
  url: process.env.VUE_APP_KEYCLOAK_AUTH_SERVER_URL,
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
}

export const keycloak = new Keycloak(options);


export const initializeKeycloak = async () => {
  const initOptions = {
    onLoad: process.env.VUE_APP_KEYCLOAK_ON_LOAD,
    redirectUri: process.env.VUE_APP_KEYCLOAK_REDIRECT_URI,
    checkLoginIframe: process.env.VUE_APP_KEYCLOAK_CHECK_LOGIN_FRAME === "true",
    pkceMethod: 'S256',
    useNonce: false
  }


  try {
    const authenticated = await keycloak.init(initOptions);
    console.info('[Keycloak] Authenticated:', authenticated);
  } catch (error) {
    console.error('[Keycloak] Initialization error:', error);
  }
};

export const kc = {
  instance: keycloak,
  login: () => keycloak.login(),
  logout: () => keycloak.logout(),
  token: () => keycloak.token,
  username: () => keycloak.tokenParsed?.preferred_username,
};


